export default __webpack_public_path__ + "static/media/change-log.c593be65.svg";